// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"9779db54","611":"d9b2f8c8"}[chunkId] + ".chunk.js";
};